// src/components/forms/Alert.tsx
import React from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
	return (
		<MuiAlert
			elevation={6}
			ref={ref}
			variant="filled"
			{...props}
			sx={{
				// If you need a box-shadow, apply it correctly here
				// boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
				...props.sx,
			}}
		/>
	);
});

export default Alert;
